<template>
  <v-container>
    <div>
      <v-data-table class="elevation-1" :headers="headers" :items="items">
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" class="mr-3" to="/admin/keuangan/submit"
              >Tambah Laporan</v-btn
            >
            <v-btn color="primary" to="/admin/keuangan/statistik"
              >Statistik Keuangan</v-btn
            >
          </v-toolbar>
          <v-text-field label="Search" class="mx-4"> </v-text-field>

          <!-- DIALOG HAPUS LAPORAN -->
          <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card>
              <v-card-title
                >Apakah anda yakin akan menghapus laporan keuangan
                ini?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="deleteConfirm" color="primary">hapus</v-btn>
                <v-btn @click="dialogDelete = false" color="secondary"
                  >batal</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon>
            <v-icon small @click="editItem(item)"> mdi-pencil </v-icon>
          </v-btn>
          <v-btn icon @click="deleteItem(item)">
            <v-icon small> mdi-delete </v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon small> mdi-file </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        { text: "Bulan Laporan", value: "date" },
        { text: "Pemasukan(Rp)", value: "income" },
        { text: "Pengeluaran(Rp)", value: "outcome" },
        { text: "Saldo Akhir(Rp)", value: "balance" },
        { text: "Aksi", value: "actions" },
      ],
      items: [],
      dialogDelete: false,
      edited: {
        inUid: "",
        outUid: "",
        masjidUid: localStorage.getItem("masjid"),
      },
    };
  },
  async created() {
    await this.axios("/keuangan/list")
      .then((response) => {
        // console.log(response.data.data, 'res keuangan list')
        let itemsIn = [];
        let itemsOut = [];

        for (let i = 0; i < response.data.data.length; i++) {
          if (response.data.data[i].transaction == "in") {
            itemsIn.push(response.data.data[i]);
          } else {
            itemsOut.push(response.data.data[i]);
          }
        }

        for (let i = 0; i < itemsIn.length; i++) {
          let obj = {};
          let total = Number(itemsIn[i].value) - Number(itemsOut[i].value);

          obj.date = itemsIn[i].date;
          obj.income = itemsIn[i].value;
          obj.outcome = itemsOut[i].value;
          obj.balance = total;
          obj.inUid = itemsIn[i].keuangan_uid;
          obj.outUid = itemsOut[i].keuangan_uid;

          this.items.push(obj);
        }
      })
      .catch((error) => {
        console.log(error, "err keuangan list");
      });

    this.items.sort(this.sortingItems);

    let totalBalance = 0;
    this.items.map((item) => {
      totalBalance += Number(item.balance);
      item.balance = totalBalance.toLocaleString("id-ID");

      item.income = Number(item.income).toLocaleString("id-ID");
      item.outcome = Number(item.outcome).toLocaleString("id-ID");
      item.date = this.$moment(item.date).format("MMMM YYYY");
    });
  },
  methods: {
    sortingItems(a, b) {
      if (a.date < b.date) {
        return -1;
      }
      if (a.date > b.date) {
        return 1;
      }
      return 0;
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.edited.inUid = item.inUid;
      this.edited.outUid = item.outUid;
    },
    deleteConfirm() {
      const querystring = require("querystring");
      //DELETE INCOME
      this.axios
        .post(
          `/keuangan/remove/${this.edited.inUid}`,
          querystring.stringify({
            masjid_uid: this.edited.masjidUid,
          })
        )
        .then((inRes) => {
          console.log(inRes, "del income res");
          //DELETE OUTCOME
          return this.axios.post(
            `/keuangan/remove/${this.edited.outUid}`,
            querystring.stringify({
              masjid_uid: this.edited.masjidUid,
            })
          );
        })
        .then((outRes) => {
          console.log(outRes, "del outcome res");
          location.reload({ forceReload: true });
          this.dialogDelete = false;
        })
        .catch((err) => {
          console.log(err, "err del process");
          this.dialogDelete = false;
        });
    },
    editItem(item) {
      let newDate = this.$moment(item.date + "-1").format("YYYY-MM");

      item.date = newDate;

      // console.log(item,'<<<<<<<<')
      this.$store.dispatch("fetchLaporan", item);
    },
  },
};
</script>

<style>
</style>